import React from 'react';
import {
  Grid,
  Toolbar,
  TextField,
  InputAdornment,
  ButtonBase,
  Button,
  Box,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { DatePicker as DatePickerComponent } from '../../components/datePicker';
import { syncTournamentCalendarReq } from '../../api/tournamentCalendar/editApi';
import { personHasRole } from '../../utils/personUtils';
import moment from 'moment';
import { PersonRole } from '../../models/eums/personRole';

export function TableToolbar(props: any) {
  const { t } = useTranslation();
  const history = useHistory();
  const isPersonAdmin = personHasRole(PersonRole.Admin);
  const calendarSync = false;

  return (
    <Toolbar style={{ marginBottom: 25 }}>
      <Grid container justify='space-between' spacing={2} direction={'row'}>
        <Grid item container xs={7} direction='column'>
          <Grid item>
            <h2 style={{ fontWeight: 'normal' }}>{props.title}</h2>
          </Grid>
          <Grid item>
            <Box hidden={!isPersonAdmin}>
              <Grid container direction='row'>
                <Grid item style={{ marginRight: '10px' }}>
                  <Button
                    variant='contained'
                    size='small'
                    color='primary'
                    onClick={() => history.push('/tournament-calendar/edit-tournament')}
                  >
                    {t('new')}
                  </Button>
                </Grid>
                {calendarSync && (
                  <Grid item>
                    <Button
                      variant='contained'
                      size='small'
                      color='primary'
                      onClick={async () => {
                        await syncTournamentCalendarReq();
                        //Let's re-fetch table data with empty search
                        props.onSearchChanged('');
                      }}
                    >
                      {t('sync_calendar')}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={2}>
          <DatePicker
            dataTableRef={props.dataTableRef}
            listFromDate={props.listFromDate}
            clearTableData={props.clearTableData}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            id='filled-search'
            label={`${t('search')}...`}
            type='search'
            margin='normal'
            variant='standard'
            value={props.searchText || ''}
            fullWidth
            onChange={ev => props.onSearchChanged(ev.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start' key='ias'>
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </Toolbar>
  );
}

interface DatePickerProps {
  dataTableRef: any;
  listFromDate: string;
  clearTableData: () => void;
}

function DatePicker(props: DatePickerProps) {
  const { dataTableRef, listFromDate, clearTableData } = props;
  const { t } = useTranslation();

  return (
    <>
      <DatePickerComponent
        margin='normal'
        id='date-picker-dialog'
        label={t('list_from')}
        format='dd.MM.yyyy.'
        value={listFromDate}
        style={{ marginBottom: 0 }}
        onChange={(date, val) => {
          if (val) {
            //Strict parse date to ensure correct user imput
            const mDate = moment(val, 'DD.MM.YYYY.', true);

            if (mDate.isValid()) {
              clearTableData();
              dataTableRef.onQueryChange({ listFromDate: mDate.format('YYYY-MM-DD') });
            }
          }
        }}
      />
      <ButtonBase
        onClick={() => {
          clearTableData();
          dataTableRef.onQueryChange({ listFromDate: moment().format('YYYY-MM-DD') });
        }}
      >
        <p
          style={{
            margin: 0,
            padding: 0,
            fontSize: 12,
          }}
        >
          {t('reset').toUpperCase()}
        </p>
      </ButtonBase>
    </>
  );
}
